const ToggleAllLocationsButton = ( {isAllOn, onClick} ) =>
    <div className="flex self-end md:justify-end py-2">
        <button className="link-3" onClick={onClick}>
            Toggle All Locations {isAllOn ? 'Off' : 'On'}
        </button>
    </div>;

export default ToggleAllLocationsButton;
